import { Stepper, StepperProps, styled } from '@mui/material';
import { StyledComponent } from '@emotion/styled';

export const StepperStyled: StyledComponent<StepperProps> = styled(Stepper)(({ theme }) => ({
  padding: theme.spacing(1, 0),
  borderRadius: theme.shape.borderRadius,
  margin: '10px 0',
  '& .stepButton': { '& .MuiStepLabel-label': { marginTop: '4px' } }
}));
